import {
  backgroundGrey2,
  fadedGrey,
  greenDark,
  themeColor,
  whiteSmoke,
  mobileWidthMax,
  red,
} from '@edulastic/colors'
import {
  EduButton,
  FlexContainer,
  RadioBtn,
  RadioGrp,
  SelectInputStyled,
  notification,
} from '@edulastic/common'
import { roleuser } from '@edulastic/constants'
import signUpState from '@edulastic/constants/const/signUpState'
import { IconClose, IconShare } from '@edulastic/icons'
import {
  Col,
  Row,
  Select,
  Spin,
  Typography,
  Modal,
  Checkbox,
  Input,
  Empty,
} from 'antd'
import { debounce, get as _get, isEqual, isUndefined, sortBy } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import styled from 'styled-components'
import { SHARE_ENTITY_TYPE } from '@edulastic/constants/const/common'
import { segmentApi } from '@edulastic/api'
import {
  getFullNameFromAsString,
  isPearOrEdulasticText,
} from '../../../../../common/utils/helpers'
import { isFeatureAccessible } from '../../../../../features/components/FeaturesSwitch'
import { getUserFeatures } from '../../../../../student/Login/ducks'
import {
  fetchUsersListAction,
  getFetchingSelector,
  getUsersListSelector,
  updateUsersListAction,
} from '../../../../sharedDucks/userDetails'
import {
  deleteSharedUserAction,
  getUserListSelector,
  receiveSharedWithListAction,
  sendTestShareAction,
  getContentSharingStateSelector,
  getShouldSendEmailStateSelector,
  getShowMessageBodyStateSelector,
  getEmailNotificationMessageSelector,
  updateEmailNotificationDataAction,
  getTestEntitySelector,
} from '../../../../TestPage/ducks'
import {
  getOrgDataSelector,
  getUserRole,
  getUserSignupStatusSelector,
  getUserNameSelector,
  getUserOrgId,
  canAccessPublicContentSelector,
} from '../../../selectors/user'
import { RadioInputWrapper } from '../RadioInput'
import { TooltipStyled } from '../../../../Dashboard/components/Showcase/components/Myclasses/components/CardAssignmentContent/styled'

const { Paragraph } = Typography
const { PLAYLIST, TEST } = SHARE_ENTITY_TYPE

const permissions = {
  EDIT: `All Actions (edit, clone, assign)`,
  VIEW: 'Limited Actions (clone, assign)',
  ASSIGN: 'View and Assign',
}

// This link sharing permission is to show in the shareModal only.
// There will be one more permission OFF for diabling the link sharing.
const linkSharingPermissions = {
  NOACTION: 'View Only (No Actions)',
  ASSIGN: 'View and Assign',
  VIEW: 'Limited Actions (clone, assign)',
}

const permissionKeys = ['ASSIGN', 'VIEW', 'EDIT']

const getPermissionKeys = (isPlaylist = false, removeEditAccess = false) => {
  let res = [...permissionKeys]
  if (isPlaylist) res = res.filter((val) => val !== 'ASSIGN')
  if (removeEditAccess) res = res.filter((val) => val !== 'EDIT')
  return res
}

const shareTypes = {
  PUBLIC: 'Everyone',
  DISTRICT: 'District',
  SCHOOL: 'School',
  INDIVIDUAL: 'Individuals',
  LINK: 'Link Sharing',
}

const sharedKeysObj = {
  PUBLIC: 'PUBLIC',
  DISTRICT: 'DISTRICT',
  SCHOOL: 'SCHOOL',
  INDIVIDUAL: 'INDIVIDUAL',
  LINK: 'LINK',
}

const shareLevel = {
  INDIVIDUAL: 0,
  SCHOOL: 1,
  DISTRICT: 2,
  PUBLIC: 3,
  LINK: 4,
}

const shareTypeKeys = ['PUBLIC', 'DISTRICT', 'SCHOOL', 'INDIVIDUAL', 'LINK']
const shareTypeKeyForDa = ['PUBLIC', 'DISTRICT', 'INDIVIDUAL', 'LINK']

const NotFoundContent = ({ isSearching }) =>
  isSearching ? (
    <Spin size="small" />
  ) : (
    <Empty
      className="ant-empty-small"
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      style={{ textAlign: 'left', margin: '10px 0' }}
      description="No match found"
    />
  )

const SharedRow = ({ data, index, getEmail, getUserName, removeHandler }) => {
  return (
    <Row
      key={index}
      style={{
        paddingBottom: 5,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Col span={12}>
        {getUserName()}
        <span>{getEmail()}</span>
      </Col>
      <Col span={11}>
        <span>
          {data.permission === 'EDIT' && 'All Actions (edit, clone, assign)'}
        </span>
        <span>
          {data.permission === 'VIEW' && 'Limited Actions (clone, assign)'}
        </span>
        <span>{data.permission === 'ASSIGN' && 'View and Assign'}</span>
        <span>
          {data.permission === 'NOACTION' && 'View Only (No Actions)'}
        </span>
      </Col>
      <Col span={1}>
        <a data-cy="share-button-close" onClick={() => removeHandler()}>
          <CloseIcon />
        </a>
      </Col>
    </Row>
  )
}
class ShareModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sharedType: sharedKeysObj.INDIVIDUAL,
      permission: (
        isUndefined(props.hasPlaylistEditAccess)
          ? props.features.editPermissionOnTestSharing
          : props.features.editPermissionOnTestSharing &&
            props.hasPlaylistEditAccess
      )
        ? 'EDIT'
        : 'VIEW',
      _permissionKeys: (
        isUndefined(props.hasPlaylistEditAccess)
          ? props.features.editPermissionOnTestSharing
          : props.features.editPermissionOnTestSharing &&
            props.hasPlaylistEditAccess
      )
        ? getPermissionKeys(props.isPlaylist)
        : getPermissionKeys(props.isPlaylist, true),
      selectedUsers: [],
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    const { features, gradeSubject, isPlaylist } = nextProps
    const { grades, subjects } = gradeSubject || {}
    const isEditPermissionNotEqual = !isEqual(
      state?.editPermissionOnTestSharing,
      features?.editPermissionOnTestSharing
    )

    const isGradesNotEqual = !isEqual(
      sortBy(state?.gradeSubject?.grades || []),
      sortBy(grades || [])
    )
    const isSubjectsNotEqual = !isEqual(
      sortBy(state?.gradeSubject?.subjects || []),
      sortBy(subjects || [])
    )
    const isGradesAndSubjectsNotEqual = isGradesNotEqual || isSubjectsNotEqual

    if (
      (isEditPermissionNotEqual || isGradesAndSubjectsNotEqual) &&
      features.editPermissionOnTestSharing === false &&
      grades &&
      subjects &&
      isFeatureAccessible({
        features,
        inputFeatures: 'editPermissionOnTestSharing',
        gradeSubject,
      })
    ) {
      return {
        permission: 'EDIT',
        _permissionKeys: getPermissionKeys(isPlaylist),
        editPermissionOnTestSharing: features?.editPermissionOnTestSharing,
        gradeSubject,
      }
    }
    if (isEditPermissionNotEqual && !features.editPermissionOnTestSharing) {
      return {
        permission: 'VIEW',
        _permissionKeys: getPermissionKeys(isPlaylist, true),
        editPermissionOnTestSharing: features?.editPermissionOnTestSharing,
      }
    }
  }

  componentDidMount() {
    const {
      getSharedUsers,
      match,
      isPlaylist,
      userRole,
      updateEmailNotificationData,
      isPublished,
      testId: _testId,
      features,
    } = this.props
    const testId = match.params.id || _testId
    const isDA = userRole === roleuser.DISTRICT_ADMIN
    if (isDA) {
      this.setState({ permission: 'VIEW' })
    }
    if (testId && testId !== 'undefined')
      getSharedUsers({
        contentId: testId,
        contentType: isPlaylist ? PLAYLIST : TEST,
      })
    updateEmailNotificationData({
      sendEmailNotification: true,
      showMessageBody: false,
      notificationMessage: '',
    })
    if (!isPlaylist) {
      if (isPublished) {
        this.setState({ permission: 'ASSIGN' })
      } else if (!isPublished && features.premium) {
        this.setState({ permission: 'EDIT' })
      }
    }
  }

  radioHandler = (e) => {
    this.setState({
      sharedType: e.target.value,
    })
    const { hasPlaylistEditAccess, updateEmailNotificationData } = this.props
    const { _permissionKeys } = this.state
    updateEmailNotificationData({
      sendEmailNotification: true,
      showMessageBody: false,
      notificationMessage: '',
    })
    if ([sharedKeysObj.PUBLIC].includes(e.target.value)) {
      this.setState({
        permission: 'VIEW',
      })
    } else if ([sharedKeysObj.LINK].includes(e.target.value)) {
      this.setState({
        permission: 'ASSIGN',
      })
    } else if (
      e.target.value !== sharedKeysObj.INDIVIDUAL ||
      !hasPlaylistEditAccess
    ) {
      this.setState({
        permission: _permissionKeys[0],
      })
    } else {
      this.setState({
        permission: 'EDIT',
      })
    }
  }

  removeHandler = (data) => {
    const { deleteShared, testId, testVersionId, isPlaylist } = this.props
    const { sharedId, _userId: sharedWith, v1Id, v1LinkShareEnabled } = data
    const unSharePayload = {
      contentId: testId,
      sharedId,
      sharedWith,
      contentType: isPlaylist ? PLAYLIST : TEST,
    }
    if (v1LinkShareEnabled === 1) {
      unSharePayload.versionId = testVersionId
      unSharePayload.v1Id = v1Id
      unSharePayload.v1LinkShareEnabled = 1
    }
    deleteShared(unSharePayload)
  }

  permissionHandler = (value) => {
    this.setState({ permission: value })
  }

  handleMultiUserSearch = (value) => {
    const { updateShareList } = this.props
    if (value.length > 2) {
      this.searchUser(value)
    } else {
      updateShareList({ data: [] })
    }
  }

  onUserSelect = (userId) => {
    const { userList = [] } = this.props
    const { selectedUsers } = this.state
    if (selectedUsers.find((o) => o._id === userId)) return

    const user = userList.find((d) => d._id === userId)
    if (user) {
      this.setState({ selectedUsers: [...selectedUsers, user] })
    }
  }

  onUserDeselect = (userId) => {
    const { selectedUsers } = this.state
    this.setState({
      selectedUsers: selectedUsers.filter((o) => o._id !== userId),
    })
  }

  searchUser = debounce((value) => {
    const { sharedType } = this.state
    const { getUsers } = this.props
    const searchBody = {
      limit: 10,
      page: 1,
      type: sharedType,
      search: {
        role: ['teacher', 'school-admin', 'district-admin'],
        searchString: value,
        status: 1,
      },
    }
    getUsers(searchBody)
  }, 500)

  handleShare = () => {
    const { sharedType, permission, selectedUsers } = this.state
    const {
      shareTest,
      testId,
      sharedUsersList,
      isPlaylist,
      testVersionId,
      authorName,
      sendEmailNotification,
      showMessageBody,
      notificationMessage,
      triggeredFrom,
      userRole,
      isTestPage,
    } = this.props
    if (triggeredFrom) {
      segmentApi.genericEventTrack('TestShare', {
        ...triggeredFrom,
        trigger: `${triggeredFrom.trigger}_share_button`,
        role: userRole,
      })
    }
    let person = {}
    if (sharedType === sharedKeysObj.INDIVIDUAL) {
      if (!selectedUsers.length) {
        return notification({ messageKey: 'pleaseSelectAnyUser' })
      }
      const alreadyShared = selectedUsers.some((user) =>
        sharedUsersList.some((item) => item._userId === user._id)
      )
      if (alreadyShared) {
        return notification({ messageKey: 'userHasPermission' })
      }
      person = {
        sharedWith: selectedUsers.map((user) => ({
          _id: user._id,
          name: getFullNameFromAsString(user._source),
          email: user._source.email,
        })),
      }
    } else {
      const isTypeExisting = sharedUsersList.some(
        (item) => item.userName === shareTypes[sharedType]
      )
      if (isTypeExisting) {
        notification({
          msg: `You have shared with ${shareTypes[sharedType]} try other option`,
        })
        return
      }
    }
    const data = {
      ...person,
      emails: [],
      sharedType,
      permission,
      contentType: isPlaylist ? PLAYLIST : TEST,
    }
    if (sharedType === sharedKeysObj.INDIVIDUAL && sendEmailNotification) {
      data.sendEmailNotification = sendEmailNotification
      data.authorName = authorName
      if (testVersionId) {
        data.testVersionId = testVersionId
      }
      if (showMessageBody) {
        if (!notificationMessage)
          return notification({
            type: 'warn',
            msg: 'Please enter the message that you want to send the users',
          })
        data.notificationMessage = notificationMessage
      }
    }
    const shareTestPayload = { data, contentId: testId }
    if (
      isTestPage &&
      !isPlaylist &&
      userRole === roleuser.TEACHER &&
      permission === 'EDIT' &&
      selectedUsers.length === 1 &&
      ['school-admin', 'district-admin'].includes(
        selectedUsers[0]._source?.role
      )
    ) {
      // Backend only supports one admin co-author per share request.
      const user = selectedUsers[0]
      shareTestPayload.adminAuthorInfo = {
        firstName: user._source.firstName || '',
        lastName: user._source.lastName || '',
        email: user._source.email,
        role:
          user._source.role === 'school-admin'
            ? roleuser.SCHOOL_ADMIN
            : roleuser.DISTRICT_ADMIN,
        _id: user._id,
      }
    }
    shareTest(shareTestPayload)
    // do it in a slight delay so that at the moment of blur it should not show warning
    setTimeout(() => {
      this.setState({ selectedUsers: [] })
    }, 0)
  }

  getUserName(data) {
    const {
      userOrgData: { districts = [{}] },
      districtId,
    } = this.props
    // share modal is not for student so we can get
    const { districtName = '' } = districts.find(
      (d) => d.districtId === districtId
    )
    if (data.sharedType === 'PUBLIC') {
      return 'EVERYONE'
    }
    if (data.sharedType === 'DISTRICT') {
      return data.shareWithName ? data.shareWithName : districtName
    }
    return `${data.userName && data.userName !== 'null' ? data.userName : ''}`
  }

  getEmail = (data) => {
    if (data.sharedType === 'PUBLIC') {
      return ''
    }
    if (data.sharedType === 'DISTRICT') {
      return ''
    }
    return `${data.email && data.email !== 'null' ? ` (${data.email})` : ''}`
  }

  toggleSendNotification = (e) => {
    const { updateEmailNotificationData } = this.props
    updateEmailNotificationData({
      sendEmailNotification: e.target.checked,
      showMessageBody: false,
      notificationMessage: '',
    })
  }

  toggleMessageBody = () => {
    const { showMessageBody, updateEmailNotificationData } = this.props
    updateEmailNotificationData({
      showMessageBody: !showMessageBody,
      notificationMessage: '',
    })
  }

  handleMessageChange = ({ target: { value } }) => {
    const { updateEmailNotificationData } = this.props
    updateEmailNotificationData({ notificationMessage: value })
  }

  handleCopyBlock = () => {
    const { isPlaylist } = this.props
    return notification({
      type: 'warn',
      msg: `Set up the sharing rule for users to view the ${
        isPlaylist ? 'playlist' : 'test'
      }`,
    })
  }

  render() {
    const {
      sharedType,
      permission,
      _permissionKeys,
      selectedUsers,
    } = this.state
    const {
      shareLabel,
      isVisible,
      onClose,
      userList = [],
      fetching,
      sharedUsersList,
      currentUserId,
      isPublished,
      testId,
      hasPremiumQuestion,
      isPlaylist,
      userOrgData,
      districtId,
      features,
      userRole,
      hasPlaylistEditAccess = true,
      testVersionId,
      userSignupStatus,
      sendEmailNotification,
      showMessageBody,
      notificationMessage,
      loadingSharedUsers,
      canAccessPublicContent,
      maxSharingLevelAllowed = shareLevel[sharedKeysObj.PUBLIC],
      triggeredFrom,
      isCustomTestType = false,
    } = this.props
    const filteredUserList = userList.filter((user) => {
      if (
        !sharedUsersList.every((people) => user._id !== people._userId) ||
        user._id === currentUserId
      ) {
        return false
      }
      return true
    })
    const multiSelectUserList = [
      ...filteredUserList,
      ...selectedUsers.filter(
        (user) => !filteredUserList.some((u) => u._id === user._id)
      ),
    ]
    let sharableURL = ''
    if (
      [sharedKeysObj.PUBLIC, sharedKeysObj.LINK].includes(sharedType) &&
      !isPlaylist
    ) {
      sharableURL = `${window.location.origin}/public/view-test/${testId}`
    } else if (isPlaylist) {
      sharableURL = `${window.location.origin}/author/playlists/${testId}`
    } else {
      sharableURL = `${window.location.origin}/author/tests/verid/${testVersionId}`
    }

    const { districts = [{}], schools } = userOrgData
    // share modal is not for student so we can get
    const { districtName = '' } = districts.find(
      (d) => d.districtId === districtId
    )
    const isDA = userRole === roleuser.DISTRICT_ADMIN
    let sharedTypeMessage = `The entire ${isPearOrEdulasticText} Community`
    if (sharedType === 'DISTRICT')
      sharedTypeMessage = `Anyone in ${districtName}`
    else if (sharedType === 'SCHOOL')
      sharedTypeMessage = `Anyone in ${schools.map((s) => s.name).join(', ')}`
    else if (sharedType === 'LINK')
      sharedTypeMessage = `Anyone with this link can access the test`

    const shareTypeKeysToDisplay = (isDA
      ? shareTypeKeyForDa
      : shareTypeKeys
    ).filter(
      (shareType) =>
        (isPlaylist &&
          ![sharedKeysObj.LINK, sharedKeysObj.PUBLIC].includes(shareType)) ||
        !isPlaylist
    )

    const individuals = sharedUsersList.filter(
      (item) => item.sharedType === sharedKeysObj.INDIVIDUAL
    )

    return (
      <SharingModal
        width="700px"
        footer={null}
        visible={isVisible}
        onCancel={onClose}
        centered
      >
        <ModalContainer>
          <h2 style={{ fontWeight: 'bold', fontSize: 20 }}>
            {isPublished
              ? 'Share with others'
              : 'Collaborate with other Co-Authors'}
          </h2>
          {!!(isPublished || (!isPublished && individuals.length)) && (
            <ShareBlock>
              {isPublished && (
                <>
                  <ShareLabel>{shareLabel || 'TEST URL'}</ShareLabel>
                  <FlexContainer>
                    {sharedUsersList.length === 0 && (
                      <CopyBlockLayer
                        data-cy="getCopyLink"
                        onClick={this.handleCopyBlock}
                      />
                    )}
                    <TitleCopy
                      copyable={{ text: sharableURL }}
                      onClick={() => {
                        if (!triggeredFrom) return
                        segmentApi.genericEventTrack('TestShare', {
                          ...triggeredFrom,
                          trigger: `${triggeredFrom.trigger}_copy_button`,
                          role: userRole,
                        })
                      }}
                    >
                      <ShareUrlDiv title={sharableURL}>
                        {sharableURL}
                      </ShareUrlDiv>
                    </TitleCopy>
                  </FlexContainer>
                </>
              )}
              {loadingSharedUsers && !sharedUsersList.length && <Spin />}
              {isPublished && sharedUsersList.length !== 0 && (
                <>
                  <ShareListTitle>WHO HAS ACCESS</ShareListTitle>
                  <ShareList data-cy="shareList">
                    {sharedUsersList.map((data, index) => (
                      <SharedRow
                        data={data}
                        key={index}
                        index={index}
                        getEmail={() => this.getEmail(data)}
                        getUserName={() => this.getUserName(data)}
                        removeHandler={() => this.removeHandler(data)}
                      />
                    ))}
                  </ShareList>
                </>
              )}
              {!isPublished && !!individuals.length && (
                <>
                  <ShareListTitle>
                    CO-AUTHORS FOR THIS {isPlaylist ? PLAYLIST : TEST}
                  </ShareListTitle>
                  <ShareList>
                    {individuals.map((data, index) => (
                      <SharedRow
                        data={data}
                        index={index}
                        getEmail={() => this.getEmail(data)}
                        getUserName={() => this.getUserName(data)}
                        removeHandler={() => this.removeHandler(data)}
                      />
                    ))}
                  </ShareList>
                </>
              )}
            </ShareBlock>
          )}
          <PeopleBlock>
            <PeopleLabel>
              {isPublished ? 'GIVE ACCESS TO' : 'Invite Co-Authors'}
            </PeopleLabel>
            {isPublished && (
              <RadioBtnWrapper>
                <RadioGrp
                  value={sharedType}
                  onChange={(e) => this.radioHandler(e)}
                >
                  {shareTypeKeysToDisplay
                    .filter((i) => {
                      return (
                        (i === sharedKeysObj.PUBLIC &&
                          canAccessPublicContent) ||
                        i !== sharedKeysObj.PUBLIC
                      )
                    })
                    .map((item) => (
                      <TooltipStyled
                        title={
                          (item === sharedKeysObj.PUBLIC ||
                            item === sharedKeysObj.LINK) &&
                          isCustomTestType
                            ? 'Sharing with Everyone is not allowed for this test.'
                            : ''
                        }
                      >
                        <RadioBtn
                          value={item}
                          key={item}
                          disabled={
                            (!isPlaylist &&
                              item !== sharedKeysObj.LINK &&
                              shareLevel[item] > maxSharingLevelAllowed) ||
                            (!isPublished &&
                              item !== sharedKeysObj.INDIVIDUAL) ||
                            (hasPremiumQuestion &&
                              item === sharedKeysObj.PUBLIC) ||
                            features.isCurator ||
                            features.isPublisherAuthor ||
                            !hasPlaylistEditAccess ||
                            (userSignupStatus ===
                              signUpState.ACCESS_WITHOUT_SCHOOL &&
                              item !== sharedKeysObj.INDIVIDUAL) ||
                            ((item === sharedKeysObj.PUBLIC ||
                              item === sharedKeysObj.LINK) &&
                              isCustomTestType)
                          }
                        >
                          {shareTypes[item]}
                        </RadioBtn>
                      </TooltipStyled>
                    ))}
                </RadioGrp>
              </RadioBtnWrapper>
            )}
            <FlexContainer
              style={{ marginTop: 5, position: 'relative' }}
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              {sharedType === sharedKeysObj.INDIVIDUAL ? (
                <UserMultiSelectWrapper>
                  <UserMultiSelectStyled
                    mode="multiple"
                    bg="white"
                    height="40px"
                    optionLabelProp="chipLabel"
                    placeholder="Enter names or email addresses"
                    value={selectedUsers.map((x) => x._id)}
                    onSearch={this.handleMultiUserSearch}
                    loading={fetching}
                    onSelect={this.onUserSelect}
                    onDeselect={this.onUserDeselect}
                    dropdownClassName="custom-antd-select"
                    filterOption={false}
                    notFoundContent={<NotFoundContent isSearching={fetching} />}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    data-cy="name-button-pop"
                  >
                    {multiSelectUserList.map(
                      ({
                        _id,
                        _source: { firstName, lastName, email, role },
                      }) => {
                        const name = `${firstName} ${lastName}`.trim()
                        return (
                          <Select.Option
                            key={_id}
                            value={_id}
                            chipLabel={name}
                            title={`${name} (${email}) [${roleuser.ROLE_LABEL[role]}]`}
                          >
                            <span>
                              {name}
                              {`(${email})`}{' '}
                              <b>{`[${roleuser.ROLE_LABEL[role]}]`}</b>
                            </span>
                          </Select.Option>
                        )
                      }
                    )}
                  </UserMultiSelectStyled>
                </UserMultiSelectWrapper>
              ) : (
                <ShareMessageWrapper data-cy="shareMessageWrapper">
                  {sharedTypeMessage}
                </ShareMessageWrapper>
              )}
              <PermissionSelectWrapper
                style={
                  [
                    sharedKeysObj.INDIVIDUAL,
                    sharedKeysObj.SCHOOL,
                    sharedKeysObj.DISTRICT,
                    sharedKeysObj.LINK,
                  ].includes(sharedType)
                    ? undefined
                    : { display: 'none' }
                }
              >
                <IndividualSelectInputStyled
                  onChange={this.permissionHandler}
                  data-cy="permission-button-pop"
                  disabled={[sharedKeysObj.PUBLIC].includes(sharedType)}
                  value={permission}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                  {sharedKeysObj.LINK !== sharedType
                    ? _permissionKeys.map((item) =>
                        (!isPublished && item === 'ASSIGN') ||
                        (item === 'EDIT' &&
                          [
                            sharedKeysObj.SCHOOL,
                            sharedKeysObj.DISTRICT,
                          ].includes(sharedType)) ? null : (
                          <Select.Option value={item} key={permissions[item]}>
                            {permissions[item]}
                          </Select.Option>
                        )
                      )
                    : Object.keys(linkSharingPermissions).map((item) => (
                        <Select.Option
                          value={item}
                          key={linkSharingPermissions[item]}
                        >
                          {linkSharingPermissions[item]}
                        </Select.Option>
                      ))}
                  {sharedKeysObj.LINK !== sharedType &&
                    !features.editPermissionOnTestSharing && (
                      <Select.Option
                        value="EDIT"
                        key={permissions.EDIT}
                        disabled
                      >
                        <TooltipStyled
                          placement="bottom"
                          $bgColor="white"
                          $color="#777777"
                          border="1px solid #D8D8D8"
                          title="Please upgrade to premium to enable this."
                        >
                          {permissions.EDIT}
                        </TooltipStyled>
                      </Select.Option>
                    )}
                </IndividualSelectInputStyled>
              </PermissionSelectWrapper>
            </FlexContainer>
          </PeopleBlock>

          {sharedType === sharedKeysObj.INDIVIDUAL && (
            <NotificationBlock color={showMessageBody ? red : themeColor}>
              <div>
                <Checkbox
                  onChange={this.toggleSendNotification}
                  checked={sendEmailNotification}
                >
                  Send Email Notification
                </Checkbox>
                {sendEmailNotification && (
                  <span onClick={this.toggleMessageBody}>
                    {showMessageBody ? '-Discard Message' : '-Add Message'}
                  </span>
                )}
              </div>
              {showMessageBody && (
                <Input.TextArea
                  placeholder="Enter Message"
                  autoSize={{ minRows: 3, maxRows: 6 }}
                  value={notificationMessage}
                  onChange={this.handleMessageChange}
                />
              )}
            </NotificationBlock>
          )}

          <DoneButtonContainer>
            <EduButton
              height="32px"
              width={!isPublished ? '175px' : null}
              onClick={onClose}
              style={{ display: 'inline-flex' }}
            >
              Cancel
            </EduButton>
            <EduButton
              height="32px"
              width={!isPublished ? '175px' : null}
              data-cy="share-button-pop"
              onClick={this.handleShare}
              style={{ display: 'inline-flex' }}
            >
              <IconShare />
              {isPublished ? 'SHARE' : 'Invite Co-Authors'}
            </EduButton>
          </DoneButtonContainer>
        </ModalContainer>
      </SharingModal>
    )
  }
}

ShareModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isPlaylist: PropTypes.bool,
  hasPremiumQuestion: PropTypes.bool,
  isPublished: PropTypes.bool,
}

ShareModal.defaultProps = {
  isPlaylist: false,
  hasPremiumQuestion: false,
  isPublished: false,
}

const enhance = compose(
  withRouter,
  connect(
    (state) => ({
      userList: getUsersListSelector(state),
      fetching: getFetchingSelector(state),
      sharedUsersList: getUserListSelector(state),
      currentUserId: _get(state, 'user.user._id', ''),
      features: getUserFeatures(state),
      userOrgData: getOrgDataSelector(state),
      districtId: getUserOrgId(state),
      userRole: getUserRole(state),
      userSignupStatus: getUserSignupStatusSelector(state),
      sharingState: getContentSharingStateSelector(state),
      authorName: getUserNameSelector(state),
      sendEmailNotification: getShouldSendEmailStateSelector(state),
      showMessageBody: getShowMessageBodyStateSelector(state),
      notificationMessage: getEmailNotificationMessageSelector(state),
      test: getTestEntitySelector(state),
      loadingSharedUsers: _get(state, 'tests.loadingSharedUsers', false),
      canAccessPublicContent: canAccessPublicContentSelector(state),
      maxSharingLevelAllowed: _get(
        state,
        'tests.maxSharingLevelAllowed',
        shareLevel[sharedKeysObj.LINK]
      ),
    }),
    {
      getUsers: fetchUsersListAction,
      updateShareList: updateUsersListAction,
      shareTest: sendTestShareAction,
      getSharedUsers: receiveSharedWithListAction,
      deleteShared: deleteSharedUserAction,
      updateEmailNotificationData: updateEmailNotificationDataAction,
    }
  )
)

export default enhance(ShareModal)

const SharingModal = styled(Modal)`
  .ant-modal-content {
    margin: 15px 0px;
  }
  .ant-modal-body {
    padding: 30px;
  }
`

const ModalContainer = styled.div`
  .anticon-down {
    svg {
      fill: ${themeColor};
    }
  }
`

const ShareBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  padding-bottom: 25px;
  border-bottom: 1px solid ${fadedGrey};
`

const ShareLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
`

const ShareMessageWrapper = styled.div`
  text-transform: uppercase;
  height: 35px;
  line-height: 35px;
  flex: 1 1 0;
  min-width: 0;
`

const ShareList = styled.div`
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  max-height: 110px;
  overflow: auto;
  width: 90%;
  margin-top: 10px;
  background: ${backgroundGrey2};

  span {
    text-transform: none;
    font-weight: normal;
  }
`

const ShareListTitle = styled.div`
  margin-top: 10px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: ${(props) => props.theme.semiBold};
`

const PeopleBlock = styled.div`
  margin-top: 25px;
  display: flex;
  flex-direction: column;

  .ant-radio {
    margin-right: 5px;
  }
`
const NotificationBlock = styled.div`
  margin-top: 15px;
  .ant-checkbox-wrapper {
    font-weight: 600;
    & + span {
      display: inline-block;
      color: ${({ color }) => color};
      cursor: pointer;
    }
  }
  > textarea {
    margin-top: 10px;
  }
`

const DoneButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`

const IndividualSelectInputStyled = styled(SelectInputStyled)`
  &.ant-select {
    @media (max-width: ${mobileWidthMax}) {
      width: 100%;
      margin-top: 5px;
      margin-right: 0px !important;
    }
  }
`

const UserMultiSelectWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  margin-right: 10px;
  align-self: flex-start;
`

const PermissionSelectWrapper = styled.div`
  flex: 1 1 0;
  min-width: 0;
  align-self: flex-start;

  ${UserMultiSelectWrapper} + & {
    flex: 0 0 270px;
    width: 270px;
    max-width: 270px;
    height: 40px;

    .ant-select {
      width: 100%;
      height: 40px;
      max-height: 40px;

      .ant-select-selection {
        box-sizing: border-box;
        height: 40px;
        min-height: 40px;
        max-height: 40px;
        align-items: center;
      }

      .ant-select-selection--single .ant-select-selection__rendered {
        line-height: 38px;
        white-space: nowrap;
      }
    }
  }

  @media (max-width: ${mobileWidthMax}) {
    width: 100%;
    margin-top: 5px;

    ${UserMultiSelectWrapper} + & {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`

const UserMultiSelectStyled = styled(SelectInputStyled)`
  &.ant-select {
    width: 100%;
    vertical-align: top;
    min-height: 40px;
    max-height: 110px;
    height: auto;

    &:not(:has(.ant-select-selection__choice)) {
      height: 40px;
    }

    .ant-select-selection.ant-select-selection--multiple {
      align-items: center;
      box-sizing: border-box;
      height: auto !important;
      min-height: 40px;
      max-height: 110px;
      overflow-y: auto;
    }

    &:has(.ant-select-selection__choice)
      .ant-select-selection.ant-select-selection--multiple {
      align-items: flex-start;
    }

    &:not(:has(.ant-select-selection__choice))
      .ant-select-selection.ant-select-selection--multiple {
      height: 40px !important;
      align-items: stretch;
    }

    &:not(:has(.ant-select-selection__choice)) .ant-select-selection__rendered {
      display: flex !important;
      align-items: center;
      width: 100%;
      min-height: 38px;
      line-height: normal;
    }

    .ant-select-selection__rendered > ul {
      display: flex !important;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      margin: 0;
      padding: 0;
      list-style: none;
      line-height: normal;
    }

    .ant-select-selection__rendered > ul > li {
      float: none !important;
    }

    .ant-select-selection__choice {
      flex: 0 0 auto;
      margin-top: 2px;
      margin-bottom: 2px;
    }

    .ant-select-selection__choice + .ant-select-search--inline {
      margin-top: 0 !important;
    }

    .ant-select-selection__choice__content {
      text-transform: none;
    }

    .ant-select-search--inline {
      flex: 1 1 auto;
      min-width: 12px;
      max-width: 100%;
      align-self: center;
      margin-top: 0 !important;
    }

    .ant-select-search--inline .ant-select-search__field__wrap {
      height: 28px;
      line-height: 28px;
      vertical-align: middle;
    }

    .ant-select-search--inline .ant-select-search__field {
      height: 28px;
      line-height: 28px;
      font-size: 13px;
      font-weight: 600;
      padding: 0 1px;
      box-sizing: border-box;
    }

    @media (max-width: ${mobileWidthMax}) {
      width: 100%;
      margin-top: 5px;
    }
  }
`

const RadioBtnWrapper = styled(RadioInputWrapper)`
  font-weight: 600;
  margin: 10px 0px;
`
const PeopleLabel = styled.span`
  font-size: 13;
  font-weight: 600;
`
const CloseIcon = styled(IconClose)`
  width: 11px;
  height: 16px;
  margin-top: 4px;
  fill: ${greenDark};
`

export const ShareUrlDiv = styled.div`
  display: flex;
  color: ${themeColor};
  font-weight: 600;
  align-items: center;
`

export const TitleCopy = styled(Paragraph)`
  div:first-child {
    background-color: ${whiteSmoke};
    display: block;
    width: 90%;
    border-radius: 4px;
    padding: 10px;
    border: 1px solid ${fadedGrey};
    color: #5d616f;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.ant-typography {
    color: ${themeColor};
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  button {
    margin-right: 10px;
  }
  .anticon {
    margin-top: 10px;
  }
  i.anticon.anticon-copy {
    display: flex;
    align-items: center;
    &:after {
      content: 'COPY';
      font-size: 12px;
      color: ${themeColor};
      margin-left: 3px;
    }
  }
  svg {
    width: 20px;
    height: 20px;
    color: ${themeColor};
  }
`
export const CopyBlockLayer = styled.div`
  position: absolute;
  width: 92%;
  height: 45px;
`
